import React from "react";
import { home } from "../../styles/theme";

const QuickLinkTiles = () => {
  const tiles = [
    { 
      title: "Tutorials", 
      desc: "Step-by-step guides to run pipelines and analyze pathogen genomics.", 
      link: "/tutorial" 
    },
    { 
      title: "News", 
      desc: "Latest updates, publications, and announcements from the PathoTrack project.", 
      link: "/news" 
    },
    { 
      title: "FAQ", 
      desc: "Frequently asked questions about using PathoTrack and its pipelines.", 
      link: "/faq" 
    },
  ];

  return (
    <div style={home.tileContainer}>
      {tiles.map((item, idx) => (
        <a
          key={idx}
          href={item.link}
          style={home.tile}
          onMouseEnter={e => {
            e.currentTarget.style.boxShadow = home.tileHover.boxShadow;
            e.currentTarget.style.transform = home.tileHover.transform;
          }}
          onMouseLeave={e => {
            e.currentTarget.style.boxShadow = home.tileDefault.boxShadow;
            e.currentTarget.style.transform = home.tileDefault.transform;
          }}
        >
          <h4>{item.title}</h4>
          <p style={home.tileDesc}>{item.desc}</p>
        </a>
      ))}
    </div>
  );
};

export default QuickLinkTiles;